// app/src/Onboard.jsx — first-run: create your workplace.
//
// Shown when a signed-in user has no workplace yet. POSTs /workplaces (caller
// becomes owner), then reloads so /me re-resolves and lands on the Board.

function Onboard() {
  const [name, setName] = React.useState('');
  const [displayName, setDisplayName] = React.useState('');
  const [lang, setLang] = window.useLang();
  const [busy, setBusy] = React.useState(false);
  const [err, setErr] = React.useState(null);

  const submit = async () => {
    const wpName = name.trim();
    if (!wpName || busy) return;
    setBusy(true); setErr(null);
    try {
      await window.crew.api('/workplaces', {
        method: 'POST',
        body: { name: wpName, displayName: displayName.trim(), defaultLang: lang, preferredLang: lang },
      });
      // Reload so main.jsx re-fetches /me and routes into the new workplace.
      window.location.hash = '/board';
      window.location.reload();
    } catch (e) {
      setErr((e && e.message) || t('onboard.error', 'Could not create workplace'));
      setBusy(false);
    }
  };

  const field = {
    width: '100%', padding: '12px 14px', marginTop: 6, marginBottom: 14,
    borderRadius: 'var(--radius-sm)', border: '1px solid var(--line)',
    background: 'var(--surface)', color: 'var(--ink)', fontSize: 15, boxSizing: 'border-box',
  };
  const label = { fontSize: 12, fontWeight: 700, color: 'var(--on-soft)' };

  return (
    <div className="crew" style={{
      height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center',
      padding: 24, background: 'var(--bg)',
    }}>
      <div style={{ width: '100%', maxWidth: 360 }}>
        <img src="/icons/kanjo-crew-app-icon.svg" alt="" style={{ width: 48, height: 48, borderRadius: 14, display: 'block', marginBottom: 18 }} />
        <h1 style={{ fontFamily: 'var(--font-head)', fontWeight: 800, fontSize: 24, color: 'var(--on)', margin: '0 0 6px' }}>
          {t('onboard.title', 'Create your workplace')}
        </h1>
        <p style={{ color: 'var(--on-soft)', fontSize: 14, margin: '0 0 22px' }}>
          {t('onboard.subtitle', "Your team's private space. You can invite crew once it's set up.")}
        </p>

        <div style={label}>{t('onboard.workplaceName', 'Workplace name')}</div>
        <input style={field} value={name} onChange={(e) => setName(e.target.value)}
          placeholder="Hanuman Thai Café" autoFocus />

        <div style={label}>{t('onboard.yourName', 'Your name')}</div>
        <input style={field} value={displayName} onChange={(e) => setDisplayName(e.target.value)}
          placeholder="Nok" />

        <div style={label}>{t('common.yourLanguage', 'Your language')}</div>
        <select style={field} value={lang} onChange={(e) => setLang(e.target.value)}>
          {window.CREW_LANGS.map((l) => <option key={l} value={l}>{window.langName(l)}</option>)}
        </select>

        {err && <div style={{ color: 'var(--primary)', fontSize: 13, marginBottom: 12 }}>{err}</div>}

        <button onClick={submit} disabled={busy || !name.trim()} style={{
          width: '100%', padding: '13px 16px', cursor: busy ? 'default' : 'pointer',
          borderRadius: 'var(--radius-sm)', border: 'none',
          background: 'var(--primary)', color: 'var(--primary-ink)', fontWeight: 700, fontSize: 15,
          opacity: busy || !name.trim() ? 0.6 : 1,
        }}>{busy ? t('onboard.creating', 'Creating…') : t('onboard.create', 'Create workplace')}</button>

        <button onClick={() => window.crew.auth.signOut()} style={{
          width: '100%', marginTop: 10, padding: '10px', cursor: 'pointer',
          border: 'none', background: 'none', color: 'var(--on-soft)', fontSize: 13, fontWeight: 600,
        }}>{t('common.signOut', 'Sign out')}</button>
      </div>
    </div>
  );
}

Object.assign(window, { Onboard });
